import { useWebContent } from '../lib/webPrices'

const HIGHLIGHTS = [
  'Přímo u 3 ha rybníka se 3 ostrovy',
  'CHKO Litovelské Pomoraví',
  'Sjezd D35 Mladeč — 5 minut',
  'Litovel — 7 minut',
  'Cyklotrasa Litovel–Bouzov',
  'Hrad Bouzov — 20 minut',
  'Olomouc — 25 minut',
  'Mazlíčci vítáni · Wi-Fi · parkování zdarma',
]

function Check() {
  return (
    <svg viewBox="0 0 24 24" className="w-4 h-4 mt-0.5 shrink-0 text-brand-500" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 12.5l5 5L20 6.5" />
    </svg>
  )
}

export function Areal() {
  const content = useWebContent()
  return (
    <section id="o-arealu" className="py-20 md:py-28 bg-white">
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <div>
            <p className="h-eyebrow">Náš areál</p>
            <h2 className="h-display text-3xl md:text-[44px] mt-4">
              Sportovní areál <span className="h-accent">Sobáčov</span>
            </h2>

            <p className="mt-6 text-ink-800 text-lg leading-relaxed">
              {(content.areal_text as string) ||
                'Rodinný areál v lužní krajině CHKO Litovelské Pomoraví, na cyklotrase Litovel–Bouzov. Vlastní 3 ha rybník se 3 ostrovy, deset rybářských chatek, pokoje penzionu, glamping, kemp a tenisové kurty.'}
            </p>

            <ul className="mt-7 grid sm:grid-cols-2 gap-x-6 gap-y-2.5">
              {HIGHLIGHTS.map((h) => (
                <li key={h} className="flex items-start gap-2.5 text-ink-800">
                  <Check />
                  <span className="text-[15px]">{h}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 flex flex-wrap gap-3">
              <a href="#ubytovani" className="btn-book">Ubytování</a>
              <a href="#galerie" className="btn-outline-dark">Galerie</a>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <img src="/img/chatka_02_rybnik_sunset.jpg" alt="Rybník se 3 ostrovy" className="aspect-[4/5] object-cover rounded-xl" />
            <img src="/img/tinyhouse_08_exterier_predni.jpg" alt="Tiny House u rybníka" className="aspect-square object-cover rounded-xl mt-10" />
            <img src="/img/gal_8.jpg" alt="Pokoj penzionu" className="aspect-square object-cover rounded-xl" />
            <img src="/img/gal_15.jpg" alt="Poctivá domácí kuchyně" className="aspect-[4/5] object-cover rounded-xl mt-10" />
          </div>
        </div>
      </div>
    </section>
  )
}
